"use client";

import { Stack, Button, Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import { CertificationsSection } from "../brand-quality/certifications_section";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

export function CertificateSection() {
  const router = useRouter();

  return (
    <Stack
      py={{ md: 25, xs: 15 }}
      gap={15}
      justifyContent="center"
      alignItems="center"
      id="home_certificate"
    >
      <CertificationsSection />
      <Stack>
        <Button
          variant="contained"
          onClick={() => router.push("/brand-quality")}
        >
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="button" color="textPrimary">
              คุณภาพของแบรนด์
            </Typography>
            <ArrowForwardRoundedIcon
              style={{
                color: "#fff",
              }}
            />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
